import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEmailPlus: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconEmailPlus"><Path d="M12 10.111L2.39697 4H21.603L12 10.111Z" fill="currentColor"/><Path d="M2 20V5.52535L12 11.889L22 5.52535V14.75H21.25V11.5H16.75V14.75H13.5V19.25H16.75V20H2Z" fill="currentColor"/><Path d="M21.25 20H22V19.25H21.25V20Z" fill="currentColor"/><Path d="M19.75 17.75V21H18.25V17.75H15V16.25H18.25V13H19.75V16.25H23V17.75H19.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEmailPlus;
